// Home Page Read More JS Starts
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('.readmore-button').forEach(function(button) {
    const content = button.closest('p')?.previousElementSibling;

    if (!content || !content.classList.contains('readmore-content')) return;

    button.addEventListener('click', function () {
      content.classList.toggle('active');
      button.textContent = content.classList.contains('active') ? 'Read Less' : 'Read More';
    });
  });
});
// Home Page Read More JS ENDS
// Collection Page Read More JS Starts
document.addEventListener("DOMContentLoaded", function () {
  // ===== Collection Page Read More =====
  const seoContent = document.querySelector("#seoContent");
  const readMoreBtn = document.querySelector(".readmore-button");

  if (seoContent && readMoreBtn) {
    const h2Elements = Array.from(seoContent.querySelectorAll("h2")).filter(
      (h2) => h2.textContent.trim() !== ""
    );

    if (h2Elements.length >= 2) {
      const secondH2 = h2Elements[1];
      const hiddenWrapper = document.createElement("div");
      hiddenWrapper.classList.add("hidden-from-2nd-h2");

      let current = secondH2;
      while (current) {
        const next = current.nextElementSibling;
        hiddenWrapper.appendChild(current);
        current = next;
      }

      seoContent.appendChild(hiddenWrapper);

      readMoreBtn.addEventListener("click", function () {
        const isExpanded = hiddenWrapper.classList.contains("expanded");
        hiddenWrapper.classList.toggle("expanded");
        readMoreBtn.textContent = isExpanded ? "Read More" : "Read Less";
      });
    } else {
      // Remove button completely if not enough H2
      readMoreBtn.remove();
    }
  }

  // ===== Blog Page Highlight Section =====
  const contentWrapper = document.querySelector(".content-wrapper");
  const blogContent = document.querySelector(".blog-content");
  const highlightBox = document.querySelector(".highlight-box");
  const tocList = document.getElementById("toc-list");

  if (blogContent && highlightBox && tocList) {
    const headings = Array.from(blogContent.querySelectorAll("h2")).filter(
      (h2) => h2.textContent.trim() !== ""
    );

    if (headings.length > 0) {
      highlightBox.style.display = "flex";

      headings.forEach((heading, index) => {
        if (!heading.id) heading.id = "heading-" + index;

        const li = document.createElement("li");
        const a = document.createElement("a");
        a.href = "#" + heading.id;
        a.textContent = heading.innerText;
        a.style.cursor = "pointer";

        a.addEventListener("click", function (e) {
          e.preventDefault();
          const target = document.getElementById(heading.id);
          const yOffset = window.innerWidth <= 768 ? -10 : -130;
          const y =
            target.getBoundingClientRect().top +
            window.pageYOffset +
            yOffset;

          window.scrollTo({ top: y, behavior: "smooth" });
        });

        li.appendChild(a);
        tocList.appendChild(li);
      });
    } else {
      // Remove the whole highlight box if no valid H2
      highlightBox.remove();
      contentWrapper.classList.add("no-highlights");
    }
  }
});

// Blog Page Highlight Section TAGS


// document.addEventListener('DOMContentLoaded', function() {
//   const MAX_QTY = 10;

//   // --- Popup ---
//   const popup = document.createElement('div');
//   popup.innerHTML = `
//     <div id="quantityLimitPopup" style="
//       display:none; position:fixed; top:0; left:0; width:100%; height:100%;
//       background:rgba(0,0,0,0.5); z-index:9999; align-items:center; justify-content:center;
//     ">
//       <div style="background:#fff; padding:2rem; border-radius:10px; max-width:600px; margin:1rem; text-align:center;">
//         <h3>For quantities more than ${MAX_QTY}, please send in your request to<br>
//         <a href="mailto:hello@jivisa.in">hello@jivisa.in</a> for a customised quote.</h3>
//         <button id="closeQtyPopup" class="button button--secondary" style="margin-top:1rem;">OK</button>
//       </div>
//     </div>`;
//   document.body.appendChild(popup);

//   const popupEl = document.getElementById('quantityLimitPopup');
//   const closeBtn = document.getElementById('closeQtyPopup');
//   closeBtn.addEventListener('click', () => popupEl.style.display = 'none');
//   popupEl.addEventListener('click', e => { if (e.target === popupEl) popupEl.style.display = 'none'; });

//   function showPopup() {
//     popupEl.style.display = 'flex';
//   }

//   // --- Core limit logic ---
//   function enforceLimit(input) {
//     const value = parseInt(input.value);
//     if (value > MAX_QTY) {
//       input.value = MAX_QTY;

//       // Try to send corrected quantity to Shopify
//       const variantId = input.dataset.quantityVariantId || input.dataset.cartItemKey;
//       if (variantId) {
//         fetch('/cart/change.js', {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify({ id: variantId, quantity: MAX_QTY })
//         }).then(r => r.json()).then(() => {
//           document.dispatchEvent(new CustomEvent('cart:refresh'));
//         }).catch(console.error);
//       }

//       showPopup();
//     }
//   }

//   // Attach listeners to current elements
//   function attachQtyWatchers() {
//     document.querySelectorAll('.quantity__input').forEach(input => {
//       if (!input.dataset.limitWatcherAttached) {
//         input.dataset.limitWatcherAttached = true;

//         input.addEventListener('input', () => enforceLimit(input));

//         // Also handle plus/minus buttons
//         const container = input.closest('quantity-input');
//         if (container) {
//           container.querySelectorAll('.quantity__button').forEach(btn => {
//             btn.addEventListener('click', () => setTimeout(() => enforceLimit(input), 100));
//           });
//         }
//       }
//     });
//   }

//   attachQtyWatchers();

//   // Observe for DOM changes (AJAX re-render)
//   const observer = new MutationObserver(() => attachQtyWatchers());
//   observer.observe(document.body, { childList: true, subtree: true });
// });

// document.addEventListener('DOMContentLoaded', function () {
//   const submitBtn = document.querySelector('.product-form__submit');
//   const qtyInput = document.querySelector('.quantity__input');
//   const popup = document.getElementById('quantityLimitPopup');
//   const closeBtn = document.getElementById('closeQuantityPopup');
//   const maxLimit = 10;

//   if (!submitBtn || !qtyInput) return;

//   submitBtn.addEventListener('click', function (e) {
//     // Get current input value
//     let currentValue = parseInt(qtyInput.value) || 0;
//     // Get data-cart-quantity attribute
//     let cartQty = parseInt(qtyInput.getAttribute('data-cart-quantity')) || 0;
//     // Add them
//     let totalQty = currentValue + cartQty;
//     // Update the input's data-cart-quantity
//     qtyInput.setAttribute('data-cart-quantity', totalQty);

//     // Show popup and prevent adding to cart if over max limit
//     if (totalQty > maxLimit) {
//       e.preventDefault(); // prevent form submission
//       popup.style.display = 'flex';
//       qtyInput.value = maxLimit; // optional: reset to max
//       return false;
//     }
//   });

//   // Close popup
//   closeBtn.addEventListener('click', function () {
//     popup.style.display = 'none';
//   });

//   popup.addEventListener('click', function (e) {
//     if (e.target === popup) popup.style.display = 'none';
//   });
// });


document.addEventListener("DOMContentLoaded", function () {

  const slider = document.querySelector(".complete-routine__list");
  const slides = document.querySelectorAll(".complete-routine__item");
  if (!slider || slides.length === 0) return;

  let isDragging = false;
  let startX = 0;
  let currentIndex = 0;

  const slideWidth = slides[0].offsetWidth + 16; // 16 = gap

  slider.addEventListener("pointerdown", (e) => {
    isDragging = true;
    startX = e.clientX;
    slider.style.cursor = "grabbing";
  });

  slider.addEventListener("pointerup", (e) => {
    if (!isDragging) return;
    isDragging = false;
    slider.style.cursor = "grab";

    const movedBy = e.clientX - startX;

    // threshold → how much drag needed to change slide
    if (movedBy < -50 && currentIndex < slides.length - 1) {
      currentIndex++;
    }

    if (movedBy > 50 && currentIndex > 0) {
      currentIndex--;
    }

    slider.scrollTo({
      left: slideWidth * currentIndex,
      behavior: "smooth"
    });
  });

});

document.addEventListener("change", function(e){

  if(!e.target.matches('.product-form__input--pill input[type="radio"]')) return;

  const uses = e.target.dataset.uses;
  const legendUses = document.getElementById("variantUsesLegend");

  if(!legendUses) return;

  if(uses && uses !== ""){
    legendUses.innerText = "Uses: " + uses;
    legendUses.style.display = "inline";
  }else{
    legendUses.style.display = "none";
  }

});

function applyGoKwikStyles() {
  const container = document.querySelector('shadow-dom-container');

  if (!container || !container.shadowRoot) return;

  let style = container.shadowRoot.getElementById('custom-gokwik-style');

  if (!style) {
    style = document.createElement('style');
    style.id = 'custom-gokwik-style';
    style.textContent = `
      @media (max-width: 449px) {
        .sidecart {
          width: 100vw !important;
          max-width: 100vw !important;
          left: 0 !important;
          right: 0 !important;
          border-radius: 0 !important;
        }
      }
    `;

    container.shadowRoot.appendChild(style);
  }
}

const interval = setInterval(() => {
  applyGoKwikStyles();

  if (document.querySelector('shadow-dom-container')?.shadowRoot) {
    clearInterval(interval);
  }
}, 500);

document.addEventListener('DOMContentLoaded', function () {
  var section = document.getElementById('shopify-section-template--27751990034613__image_with_text_3Agy4Y');

  if (section) {
    var trigger = section.querySelector('#image-full a.button.button--secondary.button--medium');

    if (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();

        var targetId = trigger.getAttribute('href').replace('#', '');
        var target = document.getElementById(targetId);

        if (target) {
          var offset = window.innerWidth < 750 ? 0 : 120;
          var targetPosition = target.getBoundingClientRect().top + window.pageYOffset - offset;
          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
          });
        }
      });
    }
  }
});

/* ------------------------------------------------------------------
   Draggable sliders: product cards are both clickable AND draggable.
   If the mouse moved more than a few px while pressed, it's a drag and
   the click is cancelled; otherwise the click opens the product.
   Touch devices are unaffected (native swipe / tap).
------------------------------------------------------------------- */
(function () {
  var DRAG_THRESHOLD = 6;
  var startX = 0, startY = 0, activeSlider = null, didDrag = false;

  function sliderFrom(target) {
    return target && target.closest
      ? target.closest('[is="scroll-snap-slider"][data-draggable="true"], .-draggable')
      : null;
  }

  window.addEventListener('mousedown', function (e) {
    if (e.button !== 0) return;
    activeSlider = sliderFrom(e.target);
    if (!activeSlider) return;
    startX = e.clientX;
    startY = e.clientY;
    didDrag = false;
  }, true);

  window.addEventListener('mousemove', function (e) {
    if (!activeSlider || didDrag) return;
    if (Math.abs(e.clientX - startX) > DRAG_THRESHOLD || Math.abs(e.clientY - startY) > DRAG_THRESHOLD) {
      didDrag = true;
    }
  }, true);

  window.addEventListener('mouseup', function () {
    if (activeSlider) setTimeout(function () { activeSlider = null; didDrag = false; }, 0);
  }, true);

  window.addEventListener('click', function (e) {
    if (didDrag && sliderFrom(e.target)) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
  }, true);

  // Stop the browser's native image/link "ghost drag" from hijacking the slide.
  window.addEventListener('dragstart', function (e) {
    if (sliderFrom(e.target)) e.preventDefault();
  }, true);
})();